import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../reminder_claim_respond';

export default function Launcher(props) {
  const config = useDialogConfig();

  const claim = useConnect('claim.byId', {
    id: config.params.claimId
  });

  if (claim.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      claim={claim}
      onClose={props.onClose}
    />
  );
};
